import { IPoint2d } from '@/editor/math/IPoint2d';
import { EFaceSide } from '@/editor/types';
import { IWallShape } from '@/editor/types/wallShape';

export enum ESeparateWallType {
  Empty = 'e',
  BaseVirtualWall = 'bv', // 基础虚拟隔墙（房间内轮廓）
  VirtualWall = 'v', // 绘制的虚拟隔墙
  SolidTabletWall = 's', // 实体隔墙
  HalfGlassWall = 'hg', //半玻璃隔墙
  GlassWall = 'g' //全玻璃隔墙
}

export type SeparateWallData = SeparateWallBaseData & SeparateWallExtraData;

/** 弧墙形态，即 `isArcSeparateWallData` 收窄后的结果：`center` 与 `clockwise` 必定存在。 */
export type TArcSeparateWallData = Omit<SeparateWallData, 'center' | 'clockwise'> &
  Required<Pick<SeparateWallData, 'center' | 'clockwise'>>;

export interface SeparateWallBaseData {
  id: string;
  thickness: number;
  height: number;
  offGround: number;
  type: ESeparateWallType;
  relateRoomId: string;
  relativeWallId: string;
  relativeWallSide: EFaceSide;
  side: EFaceSide;
  startId: number;
  endId: number;
  start: IPoint2d;
  end: IPoint2d;
  center?: IPoint2d; // 弧墙中心点
  clockwise?: boolean; // 弧墙方向
}

export interface SeparateWallExtraData {
  drawSeparateWallInfo: IWallShape;
}

export enum ESeparateWallValueBehavior {
  height = 'height',
  thickness = 'thickness',
  offGround = 'offGround',
  type = 'type',
  other = 'other'
}

export enum ESeparateWallBehavior {
  remove = 'remove',
  other = 'other'
}

export enum ESeparateWallPointBehavior {
  start = 'start',
  end = 'end',
  pan = 'pan', // 平移
  startEnd = 'startEnd',
  startEndIntersect = 'startEndIntersect'
}

export interface ISeparateWallPointBehavior {
  behavior: ESeparateWallPointBehavior;
  modifyPoints?: IPoint2d[];
  distance?: number;
}

export interface ISeparateWallValueBehavior {
  behavior: ESeparateWallValueBehavior;
  modifyValue: number | ESeparateWallType;
}

export interface ISeparateWallBehavior {
  behavior: ESeparateWallBehavior;
}

export interface ISeparateWallModifyBehaviorInfo {
  behavior: IModifySeparateWallBehavior;
  separateWallId: string;
}

export interface IModifySeparateWallBehavior {
  pointBehavior?: ISeparateWallPointBehavior;
  valueBehavior?: ISeparateWallValueBehavior;
  separateWallBehavior?: ISeparateWallBehavior;
}

export interface IConnectRelateSeparateWallInfo {
  separateWallData: SeparateWallData;
  connectPoint: IPoint2d;
}

export interface ISpecificConnectRelateSeparateWallInfo {
  startOnlyConnectRelateSeparateWallInfo?: IConnectRelateSeparateWallInfo;
  endOnlyConnectRelateSeparateWallInfo?: IConnectRelateSeparateWallInfo;
  startLapSeparateWallDataInfos?: IConnectRelateSeparateWallInfo[];
  endLapSeparateWallDataInfos?: IConnectRelateSeparateWallInfo[];
  startConnectRelateSeparateWallInfos?: IConnectRelateSeparateWallInfo[];
  endConnectRelateSeparateWallInfos?: IConnectRelateSeparateWallInfo[];
  otherConnectRelateSeparateWallInfos?: IConnectRelateSeparateWallInfo[];
}
